import { env, isProduction } from "../env";

let baseUrl = "";
let qmsUrl = "";
const protocol = location.protocol;
const ispro = location.hostname === "trace.m.ddxq.mobi";
if (ispro) {
  baseUrl = `${protocol}//gw.api.ddxq.mobi`;
  qmsUrl = `${protocol}//scm.bsapi.ddxq.mobi`;
} else {
  baseUrl = `${protocol}//gw.api.${env}.dingdongxiaoqu.com`;
  qmsUrl = `${protocol}//scm.${env}.bsapi.dingdongxiaoqu.com`;
}

export { baseUrl, isProduction, qmsUrl };
